/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

import { BASE_ENDPOINT } from '../constant';

export const requestTac = async ({
  mobileNumber,
  tacType,
}: {
  mobileNumber: string;
  tacType: string;
}): Promise<any> => {
  const baseUrl = `${BASE_ENDPOINT}`;
  const url = `${baseUrl}/tac/mobile_request_tac`;

  try {
    const config = {
      method: 'post',
      url: url,
      data: {
        mobile: mobileNumber,
        tac_type: tacType,
      },
    };
    const response = await axios.request(config);

    return response.data;
  } catch (error) {
    console.error('Fetch Error:', error);
    return {};
  }
};

export const requestGetQuote = async ({
  mobile_tac,
  tac_type,
  new_car_id,
  new_car_offer_customer_city_id,
  new_car_offer_customer_mobile,
  new_car_offer_customer_name,
  new_car_offer_customer_state_id,
  new_car_offer_type,
}: {
  tac_type: string;
  mobile_tac: number;
  new_car_id: number;
  new_car_offer_customer_city_id: number;
  new_car_offer_customer_mobile: string;
  new_car_offer_customer_name: string;
  new_car_offer_customer_state_id: number;
  new_car_offer_type: string;
}): Promise<any> => {
  const baseUrl = `${BASE_ENDPOINT}`;
  const url = `${baseUrl}/new_car_offer`;

  try {
    const config = {
      method: 'post',
      url: url,
      data: {
        tac_type,
        mobile_tac,
        new_car_id,
        new_car_offer_customer_city_id,
        new_car_offer_customer_mobile,
        new_car_offer_customer_name,
        new_car_offer_customer_state_id,
        new_car_offer_type,
      },
    };
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error('Fetch Error:', error);
    return {};
  }
};
